module.exports = __webpack_public_path__ + "img/icon-marker.ced376eb.svg";